import { render } from "./patient-medical-record.vue?vue&type=template&id=1803d292&scoped=true"
import script from "./patient-medical-record.vue?vue&type=script&lang=js"
export * from "./patient-medical-record.vue?vue&type=script&lang=js"

import "./patient-medical-record.vue?vue&type=style&index=0&id=1803d292&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1803d292"]])

export default __exports__